import React, { useEffect, useRef } from "react";
import { useLoginLogout } from "../application/Hooks/useLoginLogout";
import { useOidcAccessToken, useOidcUser } from "@axa-fr/react-oidc";

const LoginSuccessLogger = () => {
  const { LoginLogout } = useLoginLogout();
  const { accessToken } = useOidcAccessToken();
  const { oidcUser } = useOidcUser();
  const hasLogged = useRef(false); // 👈 in-memory guard for double calls

  useEffect(() => {
    const hasLoggedKey = "login-logged";

    if (
      accessToken &&
      oidcUser &&
      !sessionStorage.getItem(hasLoggedKey) &&
      !hasLogged.current // 👈 check in-memory
    ) {
      hasLogged.current = true; // 👈 prevent further calls in this render cycle

      const logLogin = async () => {
        try {
          console.log("✅ Logging login for:", oidcUser.profile?.email);
          await LoginLogout("Login");
          sessionStorage.setItem(hasLoggedKey, "true");
        } catch (error) {
          console.error("Login logging failed:", error);
        }
      };

      logLogin();
    }
  }, [accessToken, oidcUser, LoginLogout]);

  return null;
};

export default LoginSuccessLogger;
